<div class="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
  <div class="kt-subheader  kt-grid__item" id="kt_subheader">
    <div class="kt-container  kt-container--fluid ">
      <div class="kt-subheader__main">
        <h3 class="kt-subheader__title">Notificação</h3>
        <span class="kt-subheader__separator kt-subheader__separator--v"></span>
        <span class="kt-subheader__desc"><small>Notificação >> Notificação</small></span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="kt-subheader   kt-grid__item" id="kt_subheader" [hidden]="!MostrarLista">
        <div class="kt-container  kt-container--fluid ">
          <div class="kt-subheader__main">
            <div class="kt-subheader__group" id="kt_subheader_search">
              <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 kt-padding-0">
                  <form id="kt_subheader_search_form">
                    <div class="kt-input-icon kt-input-icon--right kt-subheader__search kt-padding-0">
                      <input type="search" class="form-control" placeholder="Pesquisar" name="generalSearch" #PesquisaCliente ngModel [(ngModel)]="search.PesquisaCliente">
                      <span class="kt-input-icon__icon kt-input-icon__icon--right">
                        <span>
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <rect x="0" y="0" width="24" height="24"></rect>
                              <path
                                d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                                fill="#000000" fill-rule="nonzero" opacity="0.3"></path>
                              <path
                                d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                                fill="#000000" fill-rule="nonzero"></path>
                            </g>
                          </svg>
                        </span>
                      </span>
                    </div>
                  </form>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                  <form id="kt_subheader_search_form">
                    <div class="kt-input-icon kt-input-icon--right kt-subheader__search kt-padding-0">
                      <input type="search" class="form-control" placeholder="Pesquisar" name="generalSearch" #PesquisaPaciente ngModel [(ngModel)]="search.PesquisaPaciente">
                      <span class="kt-input-icon__icon kt-input-icon__icon--right">
                        <span>
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <rect x="0" y="0" width="24" height="24"></rect>
                              <path
                                d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                                fill="#000000" fill-rule="nonzero" opacity="0.3"></path>
                              <path
                                d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                                fill="#000000" fill-rule="nonzero"></path>
                            </g>
                          </svg>
                        </span>
                      </span>
                    </div>
                  </form>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                  <form id="kt_subheader_search_form">
                    <div class="kt-input-icon kt-input-icon--right kt-subheader__search kt-padding-0">
                      <ng-select placeholder="SELECIONE" name="tp_notificacao_pesquisar" notFoundText="Nenhum item encontrado" class="form-control ng-select" #PesquisaNotificacao ngModel [(ngModel)]="search.PesquisaNotificacao">
                        <ng-option *ngFor="let opt of ListaTipoNotificacao" [value]="opt.tp_notificacao">
                          <font style="vertical-align: inherit;">{{opt.no_notificacao}}</font>
                        </ng-option>
                      </ng-select>
                      <span class="kt-input-icon__icon kt-input-icon__icon--right">
                        <span>
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <rect x="0" y="0" width="24" height="24"></rect>
                              <path
                                d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                                fill="#000000" fill-rule="nonzero" opacity="0.3"></path>
                              <path
                                d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                                fill="#000000" fill-rule="nonzero"></path>
                            </g>
                          </svg>
                        </span>
                      </span>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>


          <div class="kt-header__topbar">
            <div class="kt-header__topbar-item kt-header__topbar-item--search dropdown" id="kt_quick_search_toggle" (click)="GetNotificacao()">
              <div class="kt-header__topbar-wrapper" data-toggle="kt-popover" data-placement="top" data-content="Carregar as Notificação">
                <span class="kt-header__topbar-icon"><i class="flaticon-refresh"></i></span>
              </div>
            </div>
            <div class="kt-header__topbar-item kt-header__topbar-item--search dropdown" id="kt_quick_search_toggle">
              <div class="kt-header__topbar-wrapper" data-toggle="kt-popover" data-placement="top" (click)="CarregarTelaCadastro()" data-content="Novo Envio">
                <span class="kt-header__topbar-icon"><i class="flaticon-plus"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid" *ngIf="MostrarLista">
      <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__body kt-portlet__body--fit">
          <div class="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded" id="kt_apps_user_list_datatable">
            <table class="table table-striped- table-hover table-checkable dataTable no-footer dtr-inline" id="kt_table_1">
              <thead>
                <tr role="row">
                  <th class="sorting">Cliente</th>
                  <th class="sorting">Paciente</th>
                  <th class="sorting">Tipo Notificação</th>
                  <th class="sorting" [hidden]="VisualizacaoCelular">Periodo</th>
                  <th class="sorting" [hidden]="VisualizacaoCelular">Envio</th>
                  <th class="sorting">Nome</th>
                </tr>
              </thead>
              <tbody>
                <tr role="row" class="odd" *ngFor="let detalhe of ListaNotificacao | filtroPagination: [{no_fantasia:search.PesquisaCliente, no_paciente:search.PesquisaPaciente, tp_notificacao:search.PesquisaNotificacao}] | paginate: { itemsPerPage: 8, currentPage: p }">
                  <td>{{detalhe.no_fantasia}}</td>
                  <td>{{detalhe.no_paciente}}</td>
                  <td [hidden]="VisualizacaoCelular">{{detalhe.tp_notificacao}}</td>
                  <td [hidden]="VisualizacaoCelular">{{detalhe.dt_periodo}}</td>
                  <td [hidden]="VisualizacaoCelular">{{detalhe.dt_notificacao | date : 'dd/MM/yyyy'}}</td>
                  <td [hidden]="VisualizacaoCelular">{{detalhe.no_usuario}}</td>
                </tr>
              </tbody>
            </table>

            <div class="kt-datatable__pager kt-datatable--paging-loaded kt-padding-0">
              <div class="kt-datatable__pager-nav">
                <pagination-controls (pageChange)="p = $event" previousLabel="<" nextLabel=">"></pagination-controls>
              </div>
              <div class="kt-datatable__pager-info">
                <!-- <span class="kt-datatable__pager-detail">Mostrando {{ (ListaNotificacao | filtroPagination: [{no_fantasia:PesquisaCliente.value, no_paciente:PesquisaPaciente}])?.length }} de {{ListaNotificacao.length}}</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid" *ngIf="!MostrarLista">
      <div class="row">
        <div class="col-lg-12">
          <div class="kt-portlet">
            <form [formGroup]="formCadastroNotificacao">
              <div class="kt-portlet__body">
                <div class="form-group row">
                  <div class="col-lg-4">
                    <label>Cliente:</label>
                    <div class="kt-input-icon kt-input-icon--right">
                      <ng-select placeholder="SELECIONE" formControlName="id_cliente"  name="id_cliente" notFoundText="Nenhum item encontrado" class="form-control ng-select" (change)="GetPaciente()">
                        <ng-option *ngFor="let opt of ListaCliente" [value]="opt.id_cliente">
                          <font style="vertical-align: inherit;">{{opt.no_fantasia}}</font>
                        </ng-option>
                      </ng-select>
                      <span [hidden]="!f.id_cliente.errors" class="kt-input-icon__icon kt-input-icon__icon--right"><span><i class="flaticon-circle" [ngClass]="{ 'color-error': f.id_cliente.errors }"></i></span></span>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <label>Tipo de Notificação:</label>
                    <div class="kt-input-icon kt-input-icon--right">
                      <ng-select placeholder="SELECIONE" formControlName="tp_notificacao" name="tp_notificacao" notFoundText="Nenhum item encontrado" class="form-control ng-select">
                        <ng-option *ngFor="let opt of ListaTipoNotificacao" [value]="opt.tp_notificacao">
                          <font style="vertical-align: inherit;">{{opt.no_notificacao}}</font>
                        </ng-option>
                      </ng-select>
                      <span [hidden]="!f.tp_notificacao.errors" class="kt-input-icon__icon kt-input-icon__icon--right"><span><i class="flaticon-circle" [ngClass]="{ 'color-error': f.tp_notificacao.errors }"></i></span></span>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <label>Periodo:</label>
                    <div class="kt-input-icon kt-input-icon--right">
                      <ng-select placeholder="SELECIONE" formControlName="dt_periodo" name="dt_periodo" notFoundText="Nenhum item encontrado" class="form-control ng-select">
                        <ng-option *ngFor="let opt of ListaPeriodo" [value]="opt.dt_periodo">
                          <font style="vertical-align: inherit;">{{opt.descricao}}</font>
                        </ng-option>
                      </ng-select>
                      <span [hidden]="!f.dt_periodo.errors" class="kt-input-icon__icon kt-input-icon__icon--right"><span><i class="flaticon-circle" [ngClass]="{ 'color-error': f.dt_periodo.errors }"></i></span></span>
                    </div>
                  </div>
                  <div class="col-lg-4" *ngIf="formCadastroNotificacao.value.tp_notificacao == 'Prévia'">
                    <label>Nome do Paciente:</label>
                    <div class="kt-input-icon kt-input-icon--right">
                      <ng-select placeholder="SELECIONE" formControlName="id_paciente" name="id_paciente" notFoundText="Nenhum item encontrado" class="form-control ng-select">
                        <ng-option *ngFor="let opt of ListaPaciente" [value]="opt.id_paciente">
                          <font style="vertical-align: inherit;">{{opt.no_paciente}}</font>
                        </ng-option>
                      </ng-select>
                      <span [hidden]="!(formCadastroNotificacao.value.tp_notificacao == 'Prévia' && formCadastroNotificacao.value.id_paciente == null)" class="kt-input-icon__icon kt-input-icon__icon--right"><span><i class="flaticon-circle color-error"></i></span></span>
                    </div>
                  </div>
                  <div class="col-lg-4" *ngIf="formCadastroNotificacao.value.tp_notificacao == 'Prévia'">
                    <label>Arquivo de Prévia:</label>
                    <div class="kt-input-icon kt-input-icon--right arquivoAnexo">
                      <label class="kt-avatar__upload custom-dropzone kt-pointer kt-padding-t-10" data-toggle="kt-tooltip" style="width:100%">
                        <div class="ng-placeholder kt-padding-l-20" style="color: #999;">SELECIONE O ARQUIVO
                            <span class="kt-input-icon__icon kt-input-icon__icon--right icon" *ngIf="ListaArquivos.length == 0">
                              <span><i class="flaticon-circle color-error"></i>
                              </span>
                            </span>
                        </div>
                        <span class="form-text text-muted kt-margin-t-10" *ngIf="ListaArquivos.length > 0">Arquivo carregado com sucesso!</span>
                        <input type="file" #file placeholder="Choose file" accept=".xlsx, .xls .doc, .pdf" style="display:none;" (change)="uploadDocumento($event, '1')">
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-4" *ngIf="formCadastroNotificacao.value.tp_notificacao == 'BMS'">
                    <button type="input" class="btn btn-primary alinhamento-botao" (click)="GetBMS()" style="margin-top: 25px;" [disabled]="formCadastroNotificacao.value.dt_periodo == null">Visualizar BMS</button>
                  </div>
                </div>
                <div class="form-group row" *ngIf="novaLista_2.length > 0">
                  <div class="col-lg-4">
                    <label><b>Processos finalizados no mês:</b></label>
                  </div>
                  <div class="col-lg-8">
                    <label>{{qtd_processos}}</label>
                  </div>
                  <div class="col-lg-4">
                    <label><b>Faturado pela clinica no Mês</b></label>
                  </div>
                  <div class="col-lg-8">
                    <label>R$ {{vl_pagamento != null ? vl_pagamento.toLocaleString("pt-BR", {minimumFractionDigits: 2, maximumFractionDigits: 2  }) : '0,00'}}</label>
                  </div>
                  <div class="col-lg-4">
                    <label><b>Total do BMS á Pagar:</b></label>
                  </div>
                  <div class="col-lg-8">
                    <label>R$ {{vl_bms != null ? vl_bms.toLocaleString("pt-BR", {minimumFractionDigits: 2, maximumFractionDigits: 2  }) : '0,00'}}</label>
                  </div>
                </div>
                <div class="form-group row separador-borda" *ngFor="let detalhe of novaLista_2">
                  <div class="col-lg-4 kt-margin-t-10">
                    <label><b>Paciente:</b></label>
                  </div>
                  <div class="col-lg-8 kt-margin-t-10">
                    <label>{{detalhe.no_paciente}}</label>
                  </div>
                  <div class="col-lg-4">
                    <label><b>Procedimento:</b></label>
                  </div>
                  <div class="col-lg-8">
                    <label>{{detalhe.no_tuss}}</label>
                  </div>
                  <div class="col-lg-12 row" *ngFor="let sub_detalhe of detalhe.pagamento">
                    <div class="col-lg-4">
                      <label><b>{{sub_detalhe.no_pagamento}}:</b></label>
                    </div>
                    <div class="col-lg-8 kt-padding-l-20">
                      <label>R$ {{sub_detalhe.vl_pagamento != null ? sub_detalhe.vl_pagamento.toLocaleString("pt-BR", {minimumFractionDigits: 2, maximumFractionDigits: 2  }) : '0,00'}}</label>
                    </div>
                  </div>

                </div>
              </div>
            </form>
            <div class="kt-portlet__foot">
              <div class="kt-form__actions alinhamento-div-botao">
                <button type="reset" class="btn btn-primary alinhamento-botao" [disabled]="formCadastroNotificacao.invalid || LiberarEnvio || (formCadastroNotificacao.value.tp_notificacao == 'Prévia' && formCadastroNotificacao.value.id_paciente == null)" (click)="EnviarNotificacao()">Enviar Notificação</button>
                <button type="reset" class="btn btn-secondary" (click)="MostrarLista = !MostrarLista">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
